import axiosApi from "../services/axiosApi";

interface IRestMethodProps {
  url: string;
  body?: any;
  params?: any;
  ignoreLoading?: boolean;
  ignoreErrorNotify?: boolean;
  skipAuth?: boolean;
  headers?: Record<string, string>;
}

const useRest = () => {
  function get<T>({
    url,
    params,
    ignoreLoading,
    headers,
    ignoreErrorNotify,
    skipAuth,
  }: IRestMethodProps) {
    const configs: any = {
      params,
      ignoreLoading,
      ignoreErrorNotify,
      headers,
    };
    
    if (skipAuth) {
      configs.skipAuth = true;
    }

    return axiosApi.get<T>(url, configs);
  }

  function post<T>({
    url,
    body,
    params,
    ignoreLoading,
    headers,
    ignoreErrorNotify,
    skipAuth,
  }: IRestMethodProps) {
    const configs: any = {
      params,
      ignoreLoading,
      ignoreErrorNotify,
      headers,
    };
    
    if (skipAuth) {
      configs.skipAuth = true;
    }

    return axiosApi.post<T>(url, body, configs);
  }

  function put<T>({
    url,
    body,
    params,
    ignoreLoading,
    headers,
    ignoreErrorNotify,
  }: IRestMethodProps) {
    const configs = {
      params,
      ignoreLoading,
      ignoreErrorNotify,
      headers,
    };

    return axiosApi.put<T>(url, body, configs);
  }

  function remove<T>({
    url,
    params,
    ignoreLoading,
    headers,
    ignoreErrorNotify,
  }: IRestMethodProps) {
    const configs = {
      params,
      ignoreLoading,
      ignoreErrorNotify,
      headers,
    };

    return axiosApi.delete<T>(url, configs);
  }

  function patch<T>({
    url,
    body,
    params,
    ignoreLoading,
    headers,
    ignoreErrorNotify,
  }: IRestMethodProps) {
    const configs = {
      params,
      ignoreLoading,
      ignoreErrorNotify,
      headers,
    };

    return axiosApi.patch<T>(url, body, configs);
  }

  return {
    get,
    post,
    put,
    remove,
    patch,
  };
};

export default useRest;
